import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-14 md:py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-216">
      <div className="max-w-6xl mx-auto" data-id="element-217">
        <div className="text-center mb-8 md:mb-16" data-id="element-218">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-4" data-id="element-219">
            Elegí tu MegaPack Biología en Acción:
          </h2>
          <p className="text-2xl font-bold text-brand-blue" data-id="element-220">
            Precios de Lanzamiento
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 md:gap-8 items-stretch mb-10 md:mb-16" data-id="element-221">
          {/* Card 1: Pack Avanzado */}
          <div className="bg-white rounded-3xl p-5 md:p-8 shadow-2xl border-4 border-brand-orange relative transform lg:scale-105 z-10 flex flex-col h-full" data-id="element-222">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-orange text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-223">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-224">📗</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-225">
              PACK AVANZADO — CICLO SUPERIOR
            </h3>

            <p className="text-xl font-bold text-gray-800 text-center mb-6" data-id="element-226">
              El más completo
            </p>

            <div className="space-y-3 mb-8 flex-grow" data-id="element-227">
              <p className="text-gray-700 font-medium" data-id="element-228">
                Todo el Ciclo Básico + Ciclo Superior + Drive de Actualizaciones
              </p>
              <p className="text-gray-700 font-medium" data-id="element-229">
                Tomos 1, 2, 3, 4, 5 y 6 (1° a 6° año completo)
              </p>
              <p className="text-gray-700 font-medium" data-id="element-230">
                Los 3 Bonos Estratégicos
              </p>
              <p className="text-gray-700 font-medium" data-id="element-231">
                Acceso a actualizaciones de por vida
              </p>
            </div>

            <div className="mt-auto text-center" data-id="element-232">
              <div className="text-gray-400 text-2xl line-through font-bold mb-1" data-id="element-233">
                $39.900
              </div>
              <div className="text-4xl md:text-5xl font-black text-brand-orange mb-5 md:mb-8" data-id="element-234">
                $19.990 ARS
              </div>
              <CTAButton text="→ QUIERO PACK AVANZADO" href="https://checkout.guiadigital360.online/cart/44131411918917:1" isLink={true} className="text-xl py-4" data-id="element-235" />
            </div>
          </div>

          {/* Card 2: Combo VIP */}
          <div className="bg-white rounded-3xl p-5 md:p-8 shadow-lg border border-gray-200 flex flex-col h-full relative" data-id="element-236">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-blue text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-237">
              ⭐ UPSELL EXCLUSIVO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-238">🚀</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-239">
              COMBO GESTIÓN TOTAL VIP
            </h3>

            <p className="text-xl font-bold text-gray-800 text-center mb-2" data-id="element-240">
              ¡No sufras más con los exámenes y boletines!
            </p>
            <p className="text-base text-gray-600 text-center mb-6 font-medium" data-id="element-241">
              Contiene lo del Pack Avanzado + Gestión Total VIP
            </p>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-242">
              <p className="text-gray-700 font-medium flex items-start gap-2" data-id="element-243">
                <span data-id="element-244">✅</span> 12 Exámenes Trimestrales (2 por año) listos para
                imprimir con clave de respuestas
              </p>
              <p className="text-gray-700 font-medium flex items-start gap-2" data-id="element-245">
                <span data-id="element-246">✅</span> Guía de Frases para Boletines: 150 frases
                profesionales para copiar y pegar
              </p>
              <p className="text-gray-700 font-medium flex items-start gap-2" data-id="element-247">
                <span data-id="element-248">✅</span> 6 TP Integradores de Recuperación: El material
                listo para diciembre y febrero
              </p>
            </div>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-6" data-id="element-249">
              Ahorrás $12.000 si compras todo junto
            </div>

            <div className="mt-auto text-center" data-id="element-250">
              <div className="text-4xl md:text-5xl font-black text-brand-blue mb-5 md:mb-8" data-id="element-251">
                $24.990 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL COMBO GESTIÓN TOTAL VIP" href="https://checkout.guiadigital360.online/cart/44777826648133:1" isLink={true} className="text-lg py-4 bg-brand-blue hover:bg-blue-700 shadow-[0_8px_25px_-5px_rgba(0,87,217,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(0,87,217,0.7)]" data-id="element-252" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base text-gray-600 font-bold bg-white py-6 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-253">
          <span className="flex items-center gap-2" data-id="element-254">
            <LockIcon className="w-6 h-6 text-gray-500" data-id="element-255" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-256">
            <ZapIcon className="w-6 h-6 text-yellow-500" data-id="element-257" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-258">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-259" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-260">
            <CreditCardIcon className="w-6 h-6 text-blue-500" data-id="element-261" /> Mercado Pago ·
            Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}